import { Typography } from '@mui/material';
import React from 'react';

import MethodStepRow from './MethodStepRow';
import { caloTheme } from '../../../../assets/themes/calo';
import { FoodComponentMethodStep } from '../../../../libs';
import { getTableAttributes } from '../../../../libs/utils/helperFunctions';
import { addStepsToMethods } from '../../helpers';

interface MethodStepProps {
  methods: FoodComponentMethodStep[];
}

const MethodStep = ({ methods }: MethodStepProps) => {
  const methodsWithSteps = addStepsToMethods(methods);

  return (
    <>
      {methodsWithSteps.map((methodData, index) => (
        <React.Fragment key={`${methodData.description}-${index}`}>
          {methodData.step === 0 && (
            <Typography variant="h6">
              {methodData.station ? getTableAttributes(methodData.station, caloTheme).name : <hr />}
            </Typography>
          )}
          <MethodStepRow method={methodData} index={methodData.step} />
        </React.Fragment>
      ))}
    </>
  );
};

export default MethodStep;
